import { React, useState, useRef, useContext } from 'react'
import { FormControl, TextField, Stack, FormGroup, InputLabel, Select, MenuItem } from "@mui/material";
import TPCheckbox from "../../../TemplateProperties/TPCheckbox";
import { useTranslation } from "react-i18next";
import { cloneDeep, has, isEmpty } from "lodash";
import RegExRangeType from './RangeTypes/RegEx';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import NumericRangeType from './RangeTypes/Numeric';
import Contains from './RangeTypes/Contains';
import DateRange from './RangeTypes/DateRange';
import DateDataValidation from './DateDataValidation';
import { eachDeep } from "deepdash-es/standalone";
import { treeActions } from '../../../../redux/slices/treeSlice';
// import DateContains from './RangeTypes/DateContains';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { genericRules, keepOneDotAndNumbers, validateOnFlow, validateRevertTime, validationTime } from '../../../../utils/validate';
import dayjs from 'dayjs';


export const validationSchema = {
  MIN_LENGTH: genericRules.numericRule,
  MAX_LENGTH: genericRules.numericRule,
  RANGE_MIN: genericRules.decimal,
  RANGE_MAX: genericRules.decimal,
  MAX_REPETITION:{...genericRules.numericRule,maxLength:10},
  DATE_MAX: genericRules.dateValidate,
  DATE_MIN: genericRules.dateValidate
}



const FieldDataValidation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx);
  const rightTree = useSelector((state) => state.treeData[parentScreen].rightTree);
  const currentTab = rightTree.currentTab;
  const selectedNode = rightTree.tree[currentTab].selectedNode;
  const translatedData = rightTree.tree[currentTab].translatedData;
  const templateHeader = rightTree.tree.templateHeader;
  const [minLength, setMinLength] = useState("")
  const [dateError, setDateError] = useState({min: false, max: false});
  const [maxLength, setMaxLength] = useState("")
  const [RANGE_TYPE, setRangeType] = useState("");
  const [RANGE_EXPRESSION, setRangeExpression] = useState('');
  const [DATE_MIN, setDateMin] = useState(' ');
  const [DATE_MAX, setDateMax] = useState(' ');
  const [REQUIRED, setRequired] = useState(false);
  const [MAX_REPETITION,setMaxRepetition] = useState('');
  const [SHOULD_ALLOW_BY_PASS, setShouldAllowBypass] = useState(false);
  const [errors, setErrors] = useState({});
  const timerIdForDebounce = useRef();
  const errorRef = useRef();

  const options = [
    { value: "SELECT", text: t("SELECT") },
    { value: "NUMERIC", text: t("NUMERIC") },
    { value: "REGULAR_EXPRESSION", text: t("REGULAR_EXPRESSION") },
    { value: "CONTAINS", text: t("CONTAINS") },
  ];

  const Dateoption = [
    { value: "SELECT", text: t("SELECT") },
    { value: "NUMERIC", text: t("NUMERIC") },
    { value: "REGULAR_EXPRESSION", text: t("REGULAR_EXPRESSION") },
    { value: "CONTAINS", text: t("CONTAINS") },
    { value: "DATE_RANGE", text: t("DATE_RANGE") },
  ];

  const DataValidationDropdown = options.map((obj, key) => (
    <MenuItem key={key} value={obj.value}>
      {obj.text}
    </MenuItem>
  ));

  const DateDataValidationDropdown = Dateoption.map((obj, key) => (
    <MenuItem key={key} value={obj.value}>
      {obj.text}
    </MenuItem>
  ));

  const handleCheckbox = (key) => {
    const value = key === 'REQUIRED' ? REQUIRED : SHOULD_ALLOW_BY_PASS
    if (key === 'REQUIRED') setRequired(!value);
    else setShouldAllowBypass(!value);
    debounceUpdateRedux(selectedNode.key, { name: key, value: !value }, 500, translatedData)
  };


  const RegEX = ({ value, name }) => {
    setRangeExpression(value);
    debounceUpdateRedux(selectedNode.key, { name: name, value: value }, 500, translatedData)
  };

  const CheckDateHandler = (type) => {
    // DATE_MIN and DATE_MAX is initially " " so
    // Added condition if Date Min and Date Max are empty string inititally then it should not run this condition
    if (DATE_MIN.trim() && DATE_MAX?.trim() && dayjs(DATE_MIN).isValid() && dayjs(DATE_MAX).isValid()) {
      const minDateObj = dayjs(DATE_MIN);
      const maxDateObj = dayjs(DATE_MAX);
      const isBeforeDate = minDateObj.isBefore(maxDateObj);
      const isEqualDate = minDateObj.isSame(maxDateObj);
      
      if(isBeforeDate || isEqualDate) {
        debounceUpdateRedux(selectedNode.key, { name: [type], value: type === "DATE_MIN" ? DATE_MIN : DATE_MAX }, 500, translatedData)
      } else {
        if (type === "DATE_MIN") {
          dateErrorHandler('min',true)
          setDateMin(DATE_MAX);
          debounceUpdateRedux(selectedNode.key, { name: "DATE_MIN", value: DATE_MAX }, 500, translatedData)
          return
        }
        dateErrorHandler('max',true)
        setDateMax(DATE_MIN)
        debounceUpdateRedux(selectedNode.key, { name: "DATE_MAX", value: DATE_MIN }, 500, translatedData)
        return;
      }

      
    }
    else if ((type === "DATE_MIN" && DATE_MIN.trim()) || (type === "DATE_MAX" && DATE_MAX?.trim())) 
      debounceUpdateRedux(selectedNode.key, { name: [type], value: type === "DATE_MIN" ? DATE_MIN : DATE_MAX }, 500, translatedData)
  };

  const dateErrorHandler = (name,value) =>{
    setDateError(prev =>{ return {...prev, [name]: value}});
    setTimeout(()=>{ setDateError({min: false, max: false}) },[validationTime])
  }

  const SetMindateMaxdate = (value, name) => {
    if (name === 'DATE_MIN') setDateMin(value);
    else {
      setDateMax(value)
    }
  };

  const SetMinandMaxLength = ({ value, name },stateFunction) => {
    const errorState = validateOnFlow(name, value, validationSchema);
    stateFunction(prev => value);
    setErrors((prev) => ({
      ...prev,
      ...errorState
    }))
    
    if(isEmpty(errorState) || !value){
      debounceUpdateRedux(selectedNode.key, { name: name, value: Number(value) }, 500, translatedData)
    }

    if(!isEmpty(errorState)){

      setTimeout(()=>{
        stateFunction((prev) => {
          let val = prev;
          val = val.replace(/\D/g, '');
          if(val.length > validationSchema[name]?.maxLength){
            val = val.substring(0,validationSchema[name]?.maxLength);
          }
          return val;
        })
      },validateRevertTime)

      if(errorRef?.current?.[name]) clearTimeout(errorRef?.current?.[name]);
      const timerId= setTimeout(() => {
        setErrors((prev) => {
          const copyPrev = JSON.parse(JSON.stringify(prev));
          if(copyPrev[name]) delete copyPrev[name];
          return copyPrev;
        })
      }, validationTime)
      errorRef.current = {...errorRef.current , [name] : timerId}
      return;
    }

  };
  
  const SetMinandMaxRange = ({ value, name },stateFunction) => {
    const errorState = validateOnFlow(name, value, validationSchema);
    
    stateFunction(prev => value);
    setErrors((prev) => ({
      ...prev,
      ...errorState
    }))
    
    if(isEmpty(errorState) && !value){
      debounceUpdateRedux(selectedNode.key, { name: name, value: value }, 500, translatedData)
    }

    if(!isEmpty(errorState)){
      setTimeout(()=>{
        stateFunction((prev) => keepOneDotAndNumbers(value))
      },validateRevertTime)

      if(errorRef?.current?.[name]) clearTimeout(errorRef?.current?.[name]);
      const timerId= setTimeout(() => {
        setErrors((prev) => {
          const copyPrev = JSON.parse(JSON.stringify(prev));
          if(copyPrev[name]) delete copyPrev[name];
          return copyPrev;
        })
      }, validationTime)
      errorRef.current = {...errorRef.current , [name] : timerId}
      return;
    }
    
    
    
  };

  const checkMinMaxState = (e) => {

    let reduxData = {};

    if(e.target.name){
      reduxData[e.target.name] = e.target.value;
    }
    if(!maxLength && !minLength){
      setMinLength(prev=>'0');
      setMaxLength(prev=>'0');
    }
    if(!minLength){
      setMinLength(prev =>'0');
    }
    if (Number(minLength) >= Number(maxLength)) {
      reduxData = { ...reduxData, MIN_LENGTH:minLength, MAX_LENGTH:minLength};
      setMaxLength(prev=>minLength);
    }
    debounceUpdateRedux(selectedNode.key, null, 500, translatedData,reduxData)
  }

  const getFilteredNode = (obj = {}, value) => {
    ["RANGE_MAX", "RANGE_MIN", "DATE_MAX", "DATE_MIN", "RANGE_EXPRESSION", "RANGE_VALUES"].forEach ( e => {
      if (obj?.[e]) delete obj[e];
    })
  
    setRangeExpression('');
    setDateMin(' ');
    setDateMax(' ');
    obj['RANGE_TYPE'] = value
    return obj;
  }


  const debounceUpdateRedux = (key, value, time, data , valuesObj) => {
      const translatedData = cloneDeep(data);
      eachDeep(translatedData, (obj) => {
        const nodeKey = obj?.key;
        if (nodeKey && nodeKey === key) {
          if (value?.name === "RANGE_TYPE") obj = getFilteredNode(obj, value.value);
          if(value) obj[value.name] = value.value;
          else {
            for (let key in valuesObj){
              obj[key] = valuesObj[key];
            }
          }
          return;
        }
      })
      dispatch(
        treeActions.setNewRightTreeTranslatedData({
          screen: parentScreen,
          type: currentTab,
          data: translatedData,
        })
      );
  }

  const handleRangeType = (e) => {
    setRangeType(e.target.value)
    // let translatedData = cloneDeep(rightTree.tree[rightTree.currentTab].translatedData);
    // eachDeep(translatedData, (objValue) => {
    //   if (objValue?.key === selectedNode.key) {
    //     const modify = objValue;
    //     modify.RANGE_TYPE = e.target.value
    //     return;
    //   }
    // });
    // dispatch(treeActions.setRightTreeTransData({
    //   screen: parentScreen,
    //   type: rightTree.currentTab,
    //   data: translatedData
    // }));
    debounceUpdateRedux(selectedNode.key, { name: e.target.name, value: e.target.value }, 100, translatedData)
  }

  useEffect(() => {
    setDateMin(prev => ' ');
    setDateMax(prev => ' ');
    if (selectedNode) setRangeType(selectedNode.RANGE_TYPE || "SELECT")
    setMinLength(Number(selectedNode?.MIN_LENGTH) || "0");
    setMaxLength(Number(selectedNode?.MAX_LENGTH) || "0");
    setMaxRepetition(selectedNode?.MAX_REPETITION || 1);
    setRangeExpression(selectedNode?.RANGE_EXPRESSION || "");
    setDateMin(prev => selectedNode?.DATE_MIN || ' ')
    setDateMax(prev => selectedNode?.DATE_MAX || ' ')
    setRequired(selectedNode?.REQUIRED === "TRUE" ? true : false);
    setShouldAllowBypass(selectedNode?.SHOULD_ALLOW_BY_PASS === "TRUE" ? true : false);
    setDateError(false);
    return () => {
      setErrors({});
    }
  }, [selectedNode?.key, selectedNode?.MAX_LENGTH, selectedNode?.MIN_LENGTH, selectedNode?.REQUIRED, selectedNode?.SHOULD_ALLOW_BY_PASS, selectedNode?.DATE_MIN, selectedNode?.DATE_MAX, selectedNode?.RANGE_TYPE, selectedNode?.RANGE_EXPRESSION]);

  useEffect(() => {
    CheckDateHandler('DATE_MIN');
  }, [DATE_MIN])

  useEffect(() => {
    CheckDateHandler('DATE_MAX');
  }, [DATE_MAX])


  return (
    <>
      <Stack spacing={"20px"} className="tp-segment">
        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            autoFocus={true}
            label={t("LBL_MIN_LENGTH")}
            // type="text"
            className={"uppercase-input width-100 mui-HelperText"}
            value={minLength}
            name="MIN_LENGTH"
            onChange={(e) => SetMinandMaxLength(e.target,setMinLength)}
            onBlur={checkMinMaxState}
            helperText={errors?.MIN_LENGTH}
            error={has(errors,"MIN_LENGTH")}
          />
        </FormControl>

        <FormControl className="width-100" size="small">
          <TextField
            variant="outlined"
            size="small"
            label={t("LBL_MAX_LENGTH")}
            // type="text"
            className={"uppercase-input width-100 ml-0 mui-HelperText"}
            value={maxLength}
            name="MAX_LENGTH"
            onChange={(e) => SetMinandMaxLength(e.target,setMaxLength)}
            onBlur={checkMinMaxState}
            helperText={errors?.MAX_LENGTH}
            error={has(errors,"MAX_LENGTH")}
          />
        </FormControl>
         {(templateHeader.FILETYPE === "HL7" || (templateHeader.FILETYPE === 'EDI' && !templateHeader?.FILETYPE_VERSION?.includes('4010'))) && (
           <FormControl className='width-100' size='small'>
            <TextField
             variant='outlined'
             size='small'
             label={t('LBL_MAX_REPS')}
             type='text'
             name='MAX_REPETITION'
             value={MAX_REPETITION}
             onChange={(e)=>{SetMinandMaxLength(e.target,setMaxRepetition)}}
             onBlur={(e)=>{
              if(!e.target.value){
                setMaxRepetition(1);
              }
             }}
             helperText={errors?.MAX_REPETITION}
             error={has(errors,"MAX_REPETITION")}
             
            />

           </FormControl> 
         )}
        <FormGroup>
          <div className="flex space-between">
            <TPCheckbox
              handleCheck={
                () => handleCheckbox("REQUIRED")
              }
              label={t("BTN_FLD_REQ")}
              checked={REQUIRED}
              checkboxProps={{disabled: selectedNode?.FIELDTYPE === "CONSTANT"}}
            />
            {selectedNode.FIELDTYPE === "DATE" && <DateDataValidation handleCheckbox={handleCheckbox} debounceUpdateRedux={debounceUpdateRedux} SHOULD_ALLOW_BY_PASS={SHOULD_ALLOW_BY_PASS} />}
          </div>
          {(selectedNode.FIELDTYPE === "DATE" && SHOULD_ALLOW_BY_PASS) && <Contains action='DATE_CONTAINS' />}
        </FormGroup>
      </Stack>

      <Stack spacing={"10px"} className="tp-segment">
        <FormControl variant="outlined" className="width-100" size="small">
          <InputLabel id="rtDropdownLabel">{t("LBL_RANGE_TYPE")}</InputLabel>
          <Select
            className={"width-100"}
            label={t("LBL_RANGE_TYPE")}
            value={
              selectedNode.FIELDTYPE !== "DATE" && RANGE_TYPE === "DATE_RANGE"
                ? "SELECT"
                : RANGE_TYPE
            }
            name="RANGE_TYPE"
            onChange={(e) => {
              handleRangeType(e);
            }}
          >
            {selectedNode.FIELDTYPE === "DATE" && [DateDataValidationDropdown]}
            {selectedNode.FIELDTYPE !== "DATE" && [DataValidationDropdown]}
          </Select>
        </FormControl>
      </Stack>
      {RANGE_TYPE === "REGULAR_EXPRESSION" && (
        <RegExRangeType
          debounceUpdateRedux={debounceUpdateRedux}
          RegEX={RegEX}
          checkMinMaxState={checkMinMaxState}
          RANGE_EXPRESSION={RANGE_EXPRESSION}
        />
      )}
      {RANGE_TYPE === "NUMERIC" && <NumericRangeType />}
      {RANGE_TYPE === "CONTAINS" && <Contains action="CONTAINS" />}
      {RANGE_TYPE === "DATE_RANGE" && selectedNode.FIELDTYPE === "DATE" && (
        <DateRange
          debounceUpdateRedux={debounceUpdateRedux}
          handleCheckbox={handleCheckbox}
          SetMindateMaxdate={SetMindateMaxdate}
          checkMinMaxState={checkMinMaxState}
          CheckDateHandler={CheckDateHandler}
          DATE_MIN={DATE_MIN}
          DATE_MAX={DATE_MAX}
          dateError={dateError}
          dateErrorHandler={dateErrorHandler}
        />
      )}
    </>
  )
}

export default FieldDataValidation